import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "Do I need to provide anything?",
    a: "Yes, we just need access to a working water spigot (hose bib) and a standard 120V power outlet for our equipment. Everything else, including all soaps, polishes, towels, vacuums and steam cleaners, we bring with us.",
  },
  {
    q: "How long does a detail take?",
    a: "Most services take an average of 2 to 3 hours depending on the size and condition of the vehicle. Full details on larger SUVs or trucks may run a little longer. We'll always give you a more specific estimate when we confirm your booking.",
  },
  {
    q: "What happens if it rains?",
    a: "Southern Oregon weather can change fast. If rain is in the forecast on the day of your appointment we'll reach out and reschedule for the next available dry day at no charge. You can also call or text us anytime to reschedule.",
  },
  {
    q: "What's your cancellation policy?",
    a: "We ask that any cancellations or reschedules are made at least 24 hours before your scheduled appointment. Cancellations made within 24 hours of the appointment time will be charged a cancellation fee. Weather related reschedules are always free.",
  },
  {
    q: "Do I need to be home during the service?",
    a: "Not necessarily. As long as we have access to the vehicle, water and a power outlet, you're welcome to leave us to it. Many of our customers book during their workday or run errands while we detail.",
  },
  {
    q: "What forms of payment do you accept?",
    a: "We accept cash and Venmo. Payment is collected after the job is completed and you've had a chance to look over the vehicle.",
  },
  {
    q: "How far in advance should I book?",
    a: "We recommend booking 3 to 5 days in advance, especially during the spring and summer months. We're happy to try and accommodate last minute requests when our schedule allows, just give us a call.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-white border-t border-slate-200">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-blue-600 mb-4">FAQ</div>
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] text-slate-900">
              Good to know<br />before we arrive.
            </h2>
            <p className="mt-6 text-slate-600 leading-relaxed max-w-md">
              Don't see your question? Give us a call.{" "}
              <a href="tel:5416222960" className="text-blue-600 font-semibold hover:text-blue-700">541-622-2960</a>
              .
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="border-t border-slate-200">
              {FAQS.map((item, i) => {
                const isOpen = open === i;
                return (
                  <div key={i} className="border-b border-slate-200" data-testid={`faq-item-${i}`}>
                    <button
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      data-testid={`faq-toggle-${i}`}
                      className="w-full flex items-center justify-between py-6 text-left group"
                    >
                      <span className="font-display font-bold text-lg md:text-xl tracking-tight text-slate-900 pr-6 group-hover:text-blue-600 transition-colors">
                        {item.q}
                      </span>
                      <span className={`flex-shrink-0 h-9 w-9 grid place-items-center border-2 transition-colors ${
                        isOpen ? "bg-blue-600 border-blue-600 text-white" : "border-slate-900 text-slate-900 group-hover:border-blue-600 group-hover:text-blue-600"
                      }`}>
                        {isOpen ? <Minus size={16} strokeWidth={2.5} /> : <Plus size={16} strokeWidth={2.5} />}
                      </span>
                    </button>
                    {isOpen && (
                      <div className="pb-6 pr-12 text-slate-600 leading-relaxed text-[15px] reveal" data-testid={`faq-answer-${i}`}>
                        {item.a}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
